import { render } from "./CookiesModal.vue?vue&type=template&id=45b24acc"
import script from "./CookiesModal.vue?vue&type=script&lang=js"
export * from "./CookiesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__